import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import LandingPage from "./pages/landing-page/landing-page";
import NavBar from "./components/navbar/navbar";
import BackToTop from "./components/back-to-top/back-to-top";
import SideNavbar from "./components/side-navbar/side-navbar";
import { useEffect, useState } from "react";

import Aos from "aos";
import "aos/dist/aos.css";
import Footer from "./components/footer/footer";
import LoadingComponent from "./components/loading/loading";

function App() {
  useEffect(() => {});

  const [isLoading, setIsLoading] = useState(true);

  // Simulate loading the image
  useEffect(() => {
    Aos.init({ duration: 1000 });

    const img = new Image();
    img.src =
      "https://res.cloudinary.com/ddjpxsrej/image/upload/v1735317860/DSC093612_khmomx.png";
    img.onload = () => {
      setIsLoading(false); // Set loading to false when the image is loaded
    };
  }, []);
  return (
    <>
      {isLoading ? (
        <LoadingComponent />
      ) : (
        <Router>
          <BackToTop />
          <SideNavbar />
          <NavBar />
          <Routes>
            <Route path="/" element={<LandingPage />} />
          </Routes>
          <Footer />
        </Router>
      )}
    </>
  );
}

export default App;
